import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const DataSourceAccountIcon = ({
  width = "20",
  height = "20",
  color = "#1F2932",
  opacity = "0.4",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 12.5H13.3333V14.1667H15M15 9.16667H13.3333V10.8333H15M16.6666 15.8333H9.99996V14.1667H11.6666V12.5H9.99996V10.8333H11.6666V9.16667H9.99996V7.5H16.6666M8.33329 5.83333H6.66663V4.16667H8.33329M8.33329 9.16667H6.66663V7.5H8.33329M8.33329 12.5H6.66663V10.8333H8.33329M8.33329 15.8333H6.66663V14.1667H8.33329M4.99996 5.83333H3.33329V4.16667H4.99996M4.99996 9.16667H3.33329V7.5H4.99996M4.99996 12.5H3.33329V10.8333H4.99996M4.99996 15.8333H3.33329V14.1667H4.99996M9.99996 5.83333V2.5H1.66663V17.5H18.3333V5.83333H9.99996Z"
          fill={color}
          fillOpacity={opacity}
        />
      </svg>
    </IconWrapper>
  );
};
